import styled from 'styled-components';
import { screenSize, whiteColor, primaryColor } from '@app/styles';

type Props = {
  variant?: 'small' | 'medium' | 'large' | 'header';
};

export const SearchContainer = styled.div`
  position: relative;
  .Search-svg {
    position: absolute;
    left: 12px;
    top: calc(50% - 0.5em);
    color: #5c5f73;
  }

  .Cross-svg {
    position: absolute;
    right: 15px;
    top: calc(50% - 0.5em);
    color: #5c5f73;
    cursor: pointer;
  }
`;

export const SearchComponent = styled.input`
  width: 100%;
  height:36px;
  padding: 10px 25px 10px 32px;
  border: 1px solid rgba(179,184,188,0.30);
  border-radius: 3px;
  color: #8F99AD;
  box-shadow: none;
  background: #FFFFFF;
  outline: none;
  -webkit-appearance: none;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  ${({ variant }: Props) => {
    if (variant === 'large') {
      return `height:50px;`;
    } else if (variant === 'medium') {
      return `height:38px;`;
    } else if (variant === 'small') {
      return `height:30px;`;
    }
  }}
  @media (${screenSize.tablet}) {
    background-color:${whiteColor};
    cursor:pointer;
    border-color: rgba(179,184,188,0.30);
    &:hover {
      background-color: ${whiteColor};
       border-color: ${primaryColor};
    }
    &:active,
    &:focus {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
  }
`;

export const HeaderSearchComponent = styled.input`
  width: 100%;
  height:36px;
  padding: 10px 25px 10px 10px;
  border:none;
  border-top-left-radius: 3px;
 border-bottom-left-radius: 3px;
   color:rgb(198,205,215);
  box-shadow: none;
  background-color:rgb(57 81 115) !important ;
  outline: none;
  -webkit-appearance: none;
  ::-webkit-input-placeholder {
        color:white;
        opacity: 0.8;
            }
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  ${({ variant }: Props) => {
    if (variant === 'large') {
      return `height:50px;`;
    } else if (variant === 'medium') {
      return `height:38px;`;
    } else if (variant === 'small') {
      return `height:30px;`;
    }
  }}
  @media (${screenSize.tablet}) {
    background-color:${whiteColor};
    cursor:pointer;
    border-color: rgba(179,184,188,0.30);
    &:hover {
      background-color: ${whiteColor};
       border-color: ${primaryColor};
    }
    &:active,
    &:focus {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
  }
`;

export const ButtonContainer = styled.div`
  diasplay:   ;
  @media (${screenSize.tablet}) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 36px;
    box-shadow: inset 0 0 10px rgba(179, 184, 188, 0.3);
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    background-color: rgb(57 81 115);
    color: rgb(198, 205, 215);
    &:hover {
      box-shadow: inset 0 0 10px #000000;
    }
    &: active;
  }
`;

export const SearchBox = styled.div`
  diasplay: none;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const CrossBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    .header-Cross-svg {
      position: absolute;
      right: 60px;
      top: calc(50% - 0.5em);
      color: white;
      opacity: 0.8;
      cursor: pointer;
    }
  }
`;
